export default __webpack_public_path__ + "static/media/twitterFooter.2b552098.svg";